import { Head } from "@inertiajs/react";

interface PageHeadProps {
  title: string;
  description?: string;
}

export function PageHead({ title, description }: PageHeadProps) {
  const fullTitle = `${title} | Fleet`;

  return (
    <Head>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Head>
  );
}
